import { FC } from "react";
import { Tooltip } from "antd";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { Staff } from "../../../../types/IntelligenceTypes";
import { GenericCard } from "../../../../common/components/GenericCard";
import styles from "./WorkforceAndTalent.module.less";

interface WorkforceAndTalentProps {
    employees?: number;
    employeeIncrease?: number;
    data?: Staff;
}

export const WorkforceAndTalent: FC<WorkforceAndTalentProps> = ({
    employees = 0,
    employeeIncrease = 0,
    data,
}) => {
    const points = data?.trends.concat(data?.leadership);
    return (
        <GenericCard className={styles.card}>
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <div className={styles.title}>Work stability and talent retention</div>
                    <Tooltip
                        title="
This metric evaluates the stability of vendor's work environment and the effectiveness of your talent retention strategies. Maintaining a stable workforce is crucial for operational continuity and long-term success.

"
                    >
                        <SvgIcon name="help" size={12} color="#1890FF" />
                    </Tooltip>
                </div>
                {employees ? (
                    <div className={styles.contentMain}>
                        <div>
                            <span className={styles.employees}>
                                {employees.toLocaleString("en-US")}
                            </span>
                            <span className={styles.increase}>{employeeIncrease}% increase</span>
                        </div>
                    </div>
                ) : null}
                <ul className={styles.points}>{points?.map((p) => <li key={p}>{p}</li>)}</ul>
            </div>
        </GenericCard>
    );
};
